export default __webpack_public_path__ + "static/media/Scenery06.0cd39933.jpg";